module.exports = __webpack_public_path__ + "static/media/hs_12.cef2364d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/heads/JPEG/hs_12.jpg
// module id = 5943
// module chunks = 0